/* global React, Icon */

function Comparison() {
  const t = (k) => window.i18n.t(k);

  const rows = () => [
    { l: t("cmp.row.1.l"), cc: t("cmp.row.1.cc"), rec: t("cmp.row.1.rec"), hb: t("cmp.row.1.hb") },
    { l: t("cmp.row.2.l"), cc: t("cmp.row.2.cc"), rec: t("cmp.row.2.rec"), hb: t("cmp.row.2.hb") },
    {
      l: t("cmp.row.3.l"),
      cc: { type: "bad", v: t("cmp.row.3.cc") },
      rec: { type: "bad", v: t("cmp.row.3.rec") },
      hb: { type: "good", v: t("cmp.row.3.hb") },
    },
    {
      l: t("cmp.row.5.l"),
      cc: { type: "meh", v: t("cmp.row.5.cc") },
      rec: { type: "meh", v: t("cmp.row.5.rec") },
      hb: { type: "good", v: t("cmp.row.5.hb") },
    },
    {
      l: t("cmp.row.4.l"),
      cc: { type: "bad", v: t("cmp.row.4.cc") },
      rec: { type: "bad", v: t("cmp.row.4.rec") },
      hb: { type: "good", v: t("cmp.row.4.hb") },
    },
  ];

  const C = ({ v }) => {
    if (typeof v === "string") return <span>{v}</span>;
    if (v.type === "good")
      return (
        <span className="val-good">
          <span className="dot-g"></span>
          {v.v}
        </span>
      );
    if (v.type === "bad")
      return (
        <span className="val-bad">
          <span className="dot-r"></span>
          {v.v}
        </span>
      );
    return <span className="val-meh">{v.v}</span>;
  };

  return (
    <section className="section">
      <div className="container">
        <div className="cmp-head">
          <span className="eyebrow">{t("cmp.eyebrow")}</span>
          <h2 style={{ marginTop: 16 }}>{t("cmp.h2")}</h2>
          <p>{t("cmp.p")}</p>
        </div>
        <div className="cmp-table-wrap">
          <table className="cmp-table">
            <thead>
              <tr>
                <th scope="col">{t("cmp.th.criterion")}</th>
                <th scope="col">{t("cmp.th.cc")}</th>
                <th scope="col">{t("cmp.th.rec")}</th>
                <th scope="col" className="hb">
                  {t("cmp.th.hb")}
                </th>
              </tr>
            </thead>
            <tbody>
              {rows().map((r, i) => (
                <tr key={i}>
                  <td className="row-lbl">{r.l}</td>
                  <td>
                    <C v={r.cc} />
                  </td>
                  <td>
                    <C v={r.rec} />
                  </td>
                  <td className="hb-cell">
                    <C v={r.hb} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

window.Comparison = Comparison;
